// src/v3/ui/_common/components/layout/root-layout.tsx

import { Outlet } from "react-router-dom";
import { Header } from "./header";
import { Sidebar } from "./sidebar";

export function RootLayout() {
  return (
    <div className="flex h-screen w-full">
      <Sidebar />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col md:ml-60">
        <Header />
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
